import React from 'react';
import { Shield, Award, Star, MapPin, Heart, TrendingUp, Phone } from 'lucide-react';

const VA_BENEFITS = [
  '$0 Down Payment Options',
  'No Private Mortgage Insurance (PMI)',
  'Competitive Interest Rates',
  'Flexible Credit Requirements',
  'Streamlined Refinancing Options',
];

const MILITARY_CARDS = [
  { icon: MapPin, title: 'PCS Move Assistance', desc: "I understand the tight timelines and unique challenges of military relocations. From finding homes near base to coordinating with your command, I've got you covered." },
  { icon: Heart, title: 'Military Family Focused', desc: "I know the sacrifices military families make. That's why I go above and beyond to make your home buying or selling experience as stress-free as possible." },
  { icon: TrendingUp, title: 'BAH & Market Expertise', desc: "I'll help you find homes that fit within your BAH allowance while maximizing your investment in the coastal Virginia and North Carolina markets." },
  { icon: Shield, title: 'Base Proximity Expert', desc: 'Serving areas near NAS Oceana, Naval Station Norfolk, JEB Little Creek, Fort Eustis, Langley AFB, and Coast Guard facilities.' },
];

const MILITARY_STATS = [
  { value: '500+', label: 'Military Families Helped' },
  { value: 'MRP®', label: 'Certified Military Relocation Professional' },
  { value: '5★', label: 'Rated by Military Clients' },
];

const VeteransUnitedCard = () => (
  <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
    <div className="flex items-center space-x-4 mb-6">
      <div className="w-16 h-16 bg-gold-400 rounded-2xl flex items-center justify-center"><Award className="w-8 h-8 text-[#143160]" /></div>
      <div>
        <h3 className="text-2xl font-bold text-white">Veterans United Preferred Agent</h3>
        <p className="text-gold-400 font-semibold">Trusted VA Loan Expert</p>
      </div>
    </div>
    <p className="text-white/80 leading-relaxed mb-4">As a Veterans United Preferred Agent, I have specialized training and experience helping veterans and active-duty service members navigate the VA loan process. I work closely with Veterans United loan officers to ensure a seamless home buying experience.</p>
    <ul className="space-y-3">
      {VA_BENEFITS.map((benefit) => (
        <li key={benefit} className="flex items-center space-x-3 text-white/90">
          <Star className="w-5 h-5 text-gold-400 fill-gold-400 flex-shrink-0" />
          <span>{benefit}</span>
        </li>
      ))}
    </ul>
  </div>
);

const MilitaryCard = ({ card }) => (
  <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
    <div className="flex items-start space-x-4">
      <div className="w-12 h-12 bg-gold-400/20 rounded-xl flex items-center justify-center flex-shrink-0">
        <card.icon className="w-6 h-6 text-gold-400" />
      </div>
      <div>
        <h4 className="text-lg font-bold text-white mb-2">{card.title}</h4>
        <p className="text-white/70 text-sm">{card.desc}</p>
      </div>
    </div>
  </div>
);

export const MilitarySection = () => (
  <section id="military" className="py-16 sm:py-24 bg-gradient-to-br from-[#143160] to-[#1E4A86]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-16 space-y-6">
        <div className="inline-flex items-center space-x-3 px-6 py-3 bg-white/10 backdrop-blur-sm border-2 border-gold-400/50 rounded-full">
          <Shield className="w-5 h-5 text-gold-400" />
          <span className="text-sm font-bold text-white tracking-wide uppercase">Serving Those Who Serve</span>
        </div>
        <h2 className="text-5xl sm:text-6xl font-serif font-bold text-white leading-tight">Military Relocation<span className="block text-gold-400">Specialist</span></h2>
        <p className="text-xl text-white/80 leading-relaxed">As a certified MRP® and Veterans United Preferred Agent, I specialize in helping military families navigate PCS moves with ease.</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
        <div className="space-y-8"><VeteransUnitedCard /></div>
        <div className="space-y-6">
          {MILITARY_CARDS.map((card) => <MilitaryCard key={card.title} card={card} />)}
        </div>
      </div>
      <div className="bg-sand-50 rounded-2xl p-8 shadow-2xl">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          {MILITARY_STATS.map((stat) => (
            <div key={stat.label} className="text-center"><div className="text-5xl font-black text-[#143160] mb-2">{stat.value}</div><p className="text-gray-600 font-semibold">{stat.label}</p></div>
          ))}
        </div>
      </div>
      <div className="text-center mt-12">
        <a href="tel:252-564-5612" className="inline-flex items-center space-x-3 px-10 py-5 bg-gold-400 text-[#143160] rounded-xl shadow-2xl hover:shadow-3xl hover:scale-105 transition-all font-black text-xl">
          <Phone className="w-7 h-7" />
          <span>Call Jess: 252-564-5612</span>
        </a>
        <p className="text-white/60 mt-4 text-sm">Thank you for your service. Let me help you find your next home.</p>
      </div>
    </div>
  </section>
);
